/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { restartableTask, timeout } from 'ember-concurrency';

import Component from '@glimmer/component';

import type { IResourceName } from 'volta/models/base-model';

const DEBOUNCE_MS = 250;
interface BvFiltersSearchInputSignature {
  Args: {
    iconColor?: string;
    focused?: boolean;
    disabled?: boolean;
    resourceName: IResourceName;
    onSearchBlur?: (e: Event) => void;
    onSearchFocus?: (e: Event) => void;
    filterValues: TFilterValues;
    onSearchChange?: (filterValues: TFilterValues, query: string) => Promise<unknown> | unknown;
    searchValue?: string;
    placeholder?: string;
  };
  Element: HTMLElement;
}

export default class BvFiltersSearchInputComponent extends Component<BvFiltersSearchInputSignature> {
  searchTask = restartableTask(async (query: string) => {
    const { onSearchChange, filterValues } = this.args;

    await timeout(DEBOUNCE_MS);
    return (await onSearchChange?.({ ...filterValues }, query)) as unknown;
  });
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvFilters::SearchInput': typeof BvFiltersSearchInputComponent;
    'bv-filters/search-input': typeof BvFiltersSearchInputComponent;
  }
}
